import React from 'react';

export const PrivacyPolicy = () => {
    return (
        <div
            data-testid="privacy-policy"
            style={{
                maxWidth: '90%',
                margin: '0 auto',
                padding: '2rem',
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: 15,
                lineHeight: '160%',
                letterSpacing: 0,
                color: '#4C525D',
            }}
        >
            <h1
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 400,
                    fontSize: 35,
                    lineHeight: '56px',
                    letterSpacing: 0,
                    color: '#071424',
                    padding: '16px 0',
                }}
            >
                Privacy Policy
            </h1>
            <p style={{ fontWeight: 600 }}>Last updated: May 24, 2024</p>
            <p>
                Thank you for using TechShare.  We are committed to protecting your privacy and, for that reason, we
                have adopted this Privacy Policy to explain our data collection, use, and disclosure practices for the
                TechShare services (including its website and web-based applications, and any other tools, products, or
                services provided by Subaru of America, Inc. that link to or reference this Privacy Policy)
                (collectively, the “Services”).  The Services are owned and operated by Subaru of America, Inc.
                (“Subaru,” “we,” “us,” or “our”).
            </p>
            <p>
                This Privacy Policy applies to information Subaru collects through the Services, as well as other
                information provided to us online or offline by third parties, when we associate that information with
                customers or users of the Services.  For the avoidance of doubt, this Privacy Policy applies to
                information collected from employees of our retailers and other users of TechShare, including users of
                Subaru University.  However, it does not apply to information collected from our employees and
                contractors.  Additionally, if any user of TechShare is also the owner or occupant of a Subaru vehicle,
                Subaru’s consumer privacy policy, and not this Privacy Policy, applies to information received by Subaru
                in connection with such ownership or use of such vehicle.  You acknowledge and agree that Subaru is not
                responsible for the data collection or use practices of any other user of the Services.
            </p>
            <p>
                If you reside in the State of California, excluding our employees and contractors, please{' '}
                <a
                    href="#california"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    click here
                </a>{' '}
                to learn more about your privacy rights.  To the extent that there is a conflict between this Privacy
                Policy and the Privacy Notice for California Residents, the Privacy Notice for California Residents will
                prevail with respect to California Residents (as defined below) only.
            </p>
            <p>This Privacy Policy describes, among other things:</p>
            <ul>
                <li>Personal and other information we collect about you;</li>
                <li>How we use your information;</li>
                <li>How we may share your information with third parties; and </li>
                <li>Your choices regarding the personal information we collect about you.</li>
            </ul>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                1. Consent
            </h2>
            <p>
                By accessing or using the Services, you consent to this Privacy Policy.  If you do not agree with this
                Privacy Policy, please do not access or use the Services.  Information gathered through the Services may
                be transferred, used, and stored in the United States or in other countries where our service providers
                or we are located.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                2. Collection of Your Personal and Other Information
            </h2>
            <p>
                When you register for, or use our Services, we collect Personal Information.  By “Personal Information”
                we mean information that can identify or reasonably be linked to an individual, such as:
            </p>
            <ul>
                <li>Names;</li>
                <li>Personal or business addresses;</li>
                <li>Email addresses; and</li>
                <li>Information contained in any image, photograph or profile you submit to us.</li>
            </ul>
            <p>
                You may choose not to provide Personal Information, but this may prevent you from receiving certain
                features of the Services. We also collect non-Personal Information relating to the Services, that is,
                information that does not personally identify an individual (“Non-Personal Information”).  The
                Non-Personal Information we collect includes how you interact with the Services, information generally
                collected or “logged” by Internet websites or Internet services when accessed or used by users, and
                information about your web browser or device accessing or using the Services.  
            </p>
            <p>Examples of the Non-Personal Information we collect are:</p>
            <ul>
                <li>The pages of our website that you viewed during a visit;</li>
                <li>What information, content or advertisements you view or interact with using the Services;</li>
                <li>Language preferences;</li>
                <li>The city and state in which you are located (but not your precise geographic location); and</li>
                <li>Unique identifiers that are not connected and cannot reasonably be connected to your identity.</li>
            </ul>
            <p>
                We will not use Non-Personal Information to try to identify you, and if we associate any Non-Personal
                Information with information that personally identifies you, then we will treat it as Personal
                Information.  As discussed in more detail below, we sometimes use cookies and other automatic
                information gathering technologies to gather Non-Personal Information.  Information collected by the
                Services may be collected by us or one of our Service Providers or Online Tool Providers.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                3. Use of Your Information
            </h2>
            <p>We may use the information we collect to:</p>
            <ul>
                <li>Assist us in providing, maintaining, and protecting the Services;</li>
                <li>Set up, maintain, and protect accounts to use the Services;</li>
                <li>Improve our online operations;</li>
                <li>Process transactions;</li>
                <li>Provide customer service;</li>
                <li>
                    Communicate with you, such as provide you with account- or transaction-related communications, or
                    other newsletters, RSS feeds, and/or other communications relating to the Services;
                </li>
                <li>Send or display offers and other content that is customized to your interests or preferences;</li>
                <li>
                    Perform research and analysis aimed at improving our products and services and developing new
                    products or services; and 
                </li>
                <li>Manage and maintain the systems that provide the Services.</li>
            </ul>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                4. Disclosure of Your Information
            </h2>
            <p>
                We do not sell your Personal Information but we may disclose your Personal Information to third parties
                as described below.    We may disclose Personal Information to provide the Services, or when you
                authorize or instruct us to do so, for example when you use the Services to submit content or profile
                information.  We may also disclose Personal Information and Non-Personal Information to Service
                Providers.  By “Service Providers” we mean companies, agents, contractors, service providers, or others
                engaged to perform functions on our behalf (such as processing of payments, provision of data storage,
                hosting of our website, marketing of our products and services, and conducting audits).  When we use a
                Service Provider, we require that the Service Provider use and disclose the Personal Information and
                Non-Personal Information received from us only to provide their services to us or as required by
                applicable law.
            </p>
            <p>
                We may also disclose Personal Information and Non-Personal Information to Online Tool Providers.  By
                “Online Tool Provider” we mean a licensor of software that we include in, or use with, the Services,
                including an API or SDK, that provides a specialized function or service to us and that requires the
                transmission of Personal Information and/or Non-Personal Information to the Online Tool Provider. 
                Online Tool Providers may have the right to use Personal Information and Non-Personal Information about
                you for their own business purposes.  Use and disclosure of Personal Information and Non-Personal
                Information by an Online Tool Provider is described in its privacy policy.  See Section 5 below for some
                of the key Online Tool Providers we use.
            </p>
            <p>
                We may partner with advertisers to provide you with special offers, or to advertise products or services
                to you.  If you redeem or respond to an offer, we may provide your Personal Information to the
                advertising partner, including your name, email address, gender, and year of birth.  If you answer
                questions or fill out surveys from an advertiser, we may share information with that advertiser.  The
                advertising partner’s privacy policy will govern their use of your information, which may include
                marketing of other products or services to you.  You should read each advertiser’s privacy policy before
                providing information to that advertiser.
            </p>
            <p>
                We may also disclose your Personal Information to third parties when we believe, in good faith and in
                our sole discretion, that such disclosure is reasonably necessary to (a) enforce or apply the terms and
                conditions of the Services, including investigation of potential violations thereof, (b) comply with
                legal or regulatory requirements or an enforceable governmental request, (c) protect the rights,
                property or safety of us, our users or other third parties, (d) prevent a crime or protect national
                security, or (e) detect, prevent or otherwise address fraud, security or technical issues.   We reserve
                the right to transfer information (including your Personal Information) to a third party in the event of
                a sale, merger, or transfer of all or substantially all of the assets of our company relating to the
                Services, or in the unlikely event of a bankruptcy, liquidation, or receivership of our business.  We
                will use commercially reasonable efforts to notify you of such transfer, for example via email or by
                posting notice on our website. Lastly, we may also disclose Non-Personal Information, aggregated with
                information about our other users, to our clients, business partners, merchants, advertisers, investors,
                potential buyers and other third parties if we deem such disclosure, in our sole discretion, to have
                sound business reasons or justifications.  
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                5. Cookies and Automatic Information Gathering Technologies
            </h2>
            <p>
                Every time you use the Services (e.g., access a Service webpage, navigate to a specific location within
                the Service mobile app), we collect Personal Information and Non-Personal Information (discussed above
                in Section 2) regarding that use.  For example, to improve our Services, we collect how, when, and which
                parts of the Services or its features you use.  Also, we may use your device’s unique identifier (UDID)
                or other unique identifiers to assist us in collecting and analyzing this data.
            </p>
            <p>
                To assist us in collecting and storing this Non-Personal Information, we may employ a variety of
                technologies, including “Cookies,” local browser storage, and “web beacons,” “pixels,” or “tags.”  A
                “Cookie” is a small amount of data a website operator, or a third party whose content is embedded in
                that website, may store in your web browser and that the website operator or, as applicable, the third
                party, can access when you visit the website.  A web beacon, pixel or tag is a small,
                usually-transparent image or script placed on a web page that allows the operator of that image or
                script, which may be the operator of the website you visit or a third party, to read or write a Cookie.
            </p>
            <p>
                Your operating system and web browser may allow you to erase information stored in Cookies and local
                browser storage. But if you do so, you may be forced to login to the Services again and you may lose
                some preferences or settings.  You may also be able to set your browser to refuse all website storage or
                to indicate when it is permitted, but some features of our Services may not function properly without
                it. We may use Cookies to keep you logged in, save your preferences for the Services, and to collect
                information about how you use our Services.   More information about managing Cookies is available{' '}
                <a
                    href="#"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    here
                </a>
                .  To learn how to manage privacy and storage settings for your local browser storage, please refer to
                the end user documentation for your browser.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                6. Transparency and Choice; Do Not Track Signals
            </h2>
            <p>
                You may request access to your Personal Information by contacting us at{' '}
                <a
                    href="https://www.subaru.com/contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    Subaru.com/contactus
                </a>
                .  We will try to locate and provide you with your Personal Information and give you the opportunity to
                correct this data, if it is inaccurate, or to delete it, at your request.   But, in either case, we may
                need to retain it for legal reasons or for legitimate business purposes.  You may also remove any
                content that you post to the Services using the deletion or removal options within the Service. 
                However, we (and you) are not able to control information that you have already shared with other users
                or made available to third parties through the Services.
            </p>
            <p>
                If you need further assistance with removing any content you posted through the Services, you can
                contact us at{' '}
                <a
                    href="https://www.subaru.com/contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    Subaru.com/contactus
                </a>
                .  Removal of your posted content may not ensure complete or comprehensive removal from our computer
                systems.  We ask individual users to identify themselves and the information requested to be accessed,
                corrected, or removed before processing such requests, and we may decline to process requests that are
                unreasonably repetitive or systematic, require disproportionate technical effort, jeopardize the privacy
                of others, would be extremely impractical (for instance, requests concerning information residing on
                backups), or relate to information that is not associated with your Personal Information.  In any case,
                where we provide information access and correction, we perform this service free of charge, except if
                doing so would require a disproportionate effort. 
            </p>
            <p>
                Please be aware that if you ask us to delete your Personal Information, you may not be able to continue
                to use the Services.  Also, even if you request that we delete your Personal Information, we may need to
                retain certain information for a limited period of time to satisfy our legal, audit and/or dispute
                resolution requirements.
            </p>
            <p>
                We support the development and implementation of a standard "do not track" browser feature that provides
                customers with control over the collection and use of information about their web-browsing activities.
                To learn more about "Do Not Track", please visit{' '}
                <a
                    href="https://allaboutdnt.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    All About Do Not Track
                </a>
                . Once a standardized "do not track" feature is released, we intend to adhere to the browser settings
                accordingly. 
            </p>
            <p>
                You can opt out of receiving marketing e-mails from us by clicking on the “unsubscribe” link in the
                e-mails.  Please note that it may take up to ten (10) business days for your opt-out request to be
                processed.  Also, even if you opt out of marketing e-mails, we may continue to send you certain
                account-related e-mails, such as notices about your account and confirmations of transactions you have
                requested. 
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                7. Residents of Nevada
            </h2>
            <p>
                We do not sell your Personal Information.  However, you may contact us at{' '}
                <a
                    href="https://www.subaru.com/contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    Subaru.com/contactus
                </a>{' '}
                with questions.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                8. Children
            </h2>
            <p>
                The Services are not intended for users under 13 years of age.  We do not knowingly collect Personal
                Information from users under 13 years of age.  We do not authorize users under 13 years of age to use
                the Services.  If you are the parent or guardian and have learned or suspect that your child under the
                age of 13 has provided us with Personal Information, please contact us at{' '}
                <a
                    href="https://www.subaru.com/contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    Subaru.com/contactus
                </a>{' '}
                and provide us with the name and email address that was used and we will promptly delete such
                information.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                9. Information Security
            </h2>
            <p>
                We utilize reasonable information security measures to safeguard your Personal Information against
                unauthorized access, modification, or destruction.  For example, we utilize Secure Socket Layer (SSL),
                Transport Layer Security (TLS), or similar encryption technology when sensitive data is transmitted over
                the Internet, and use firewalls to help prevent external access into our network.  However, no data
                transmission over the Internet and no method of data storage can be guaranteed to be 100% secure. 
                Therefore, while we strive to use commercially acceptable means to protect your Personal Information, we
                cannot guarantee its security. We restrict access to Personal Information in our possession to our
                employees, Service Providers, and Online Tool Providers who need to know that information in order to
                operate, develop, improve or support our Services. If we share Personal Information with Service
                Providers or Online Tool Providers, we require that they also use reasonable information security
                measures to safeguard your Personal Information.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                10. Third Party Websites
            </h2>
            <p>
                Please note that the Services may link or integrate with third-party sites, services or apps.   We are
                not responsible for the privacy or security policies or practices or the content of such third parties. 
                Accordingly, we encourage you to review the privacy and security policies and terms of service of those
                third parties so that you understand how those websites collect, use, share and protect your
                information.
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                11. Changes to this Policy
            </h2>
            <p>
                We may modify or update this Privacy Policy periodically with or without prior notice by posting the
                updated policy on this page. You can always check the “Last Updated” date at the top of this document to
                see when the Privacy Policy was last changed.  If we make any material changes to this Privacy Policy,
                we will notify you by reasonable means, which may be by e-mail or posting a notice of the changes on our
                website prior to the changes becoming effective.  We encourage you to check this Privacy Policy from
                time to time.  IF YOU DO NOT AGREE TO CHANGES TO THIS PRIVACY POLICY, YOU MUST STOP USING THE SERVICES
                AFTER THE EFFECTIVE DATE OF SUCH CHANGES (WHICH IS THE “LAST UPDATED” DATE OF THIS PRIVACY POLICY).
            </p>
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                12. Questions
            </h2>
            <p>To ask questions about our Privacy Policy or to file a complaint, contact us at:</p>
            <address style={{ fontStyle: 'normal' }}>
                Subaru of America, Inc.
                <br />
                One Subaru Drive
                <br />
                Camden, NJ 08103
                <br />
                <a
                    href="https://www.subaru.com/contactus"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        textDecoration: 'underline',
                        color: '#4C525D',
                        fontWeight: 400,
                        fontFamily: 'Roboto',
                        fontSize: 15,
                        lineHeight: '160%',
                        letterSpacing: 0,
                    }}
                >
                    Subaru.com/contactus
                </a>
            </address>
            <hr />
            <h2
                style={{
                    fontFamily: 'Roboto',
                    fontWeight: 600,
                    fontSize: 17,
                    lineHeight: '24px',
                    letterSpacing: 0,
                }}
            >
                Privacy Notice for California Residents
            </h2>
            <p>
                This Privacy Notice for California Residents (the “Notice”) supplements the information contained in our
                Privacy Policy and applies only if you reside in the State of California (you are a “California
                Resident”).
            </p>
            <p>
                For purposes of this Notice “Sell,” “Selling,” “Sale,” or “Sold,” means selling, renting, releasing,
                disclosing, disseminating, making available, transferring, or otherwise communicating orally, in
                writing, or by electronic or other means, Personal Information to another business or a third party for
                monetary or other valuable consideration.
            </p>
            <p>
                “Share”, “Shared,” or “Sharing” means sharing, renting, releasing, disclosing, disseminating, making
                available, transferring, or otherwise communicating orally, in writing, or by electronic or other means,
                Personal Information to a third party for Cross-context Behavioral Advertising, whether or not for
                monetary or other valuable consideration.
            </p>
            <p>
                “Cross-context Behavioral Advertising” means the targeting of advertising to a consumer based on that
                consumer’s Personal Information obtained from activity across businesses or distinctly branded websites,
                applications, or services, other than the business or distinctly-branded website, application, or
                service with which the consumer intentionally interacts.  (In other words, if we send you an ad based
                solely on your interaction with us or our Services, this is not Cross-context Behavioral Advertising.)
            </p>
            <p>
                “Sensitive Personal Information” means Personal Information that is not publicly available and reveals
                one or more of the following:
            </p>
            <ul>
                <li>A consumer’s Social Security, driver’s license, state identification card, or passport number;</li>
                <li>
                    A consumer’s account log-in, financial account, debit card or credit card number in combination with
                    any required security or access code, password, or credentials allowing access to an account;
                </li>
                <li>A consumer’s precise geolocation;</li>
                <li>A consumer’s racial or ethnic origin, religious or philosophical beliefs, or union membership;</li>
                <li>
                    The contents of a consumer’s mail, email, and text messages unless we are the intended recipient of
                    the communication;
                </li>
                <li>A consumer’s genetic or biometric data; or</li>
                <li>
                    Personal Information collected and analyzed concerning a consumer’s health, sex life, or sexual
                    orientation.
                </li>
            </ul>
            <p>
                “Verifiable Request” means that the identifying information provided by a consumer in connection with a
                request matches the Personal Information of the consumer already maintained by us. Identifying
                information includes your name and contact information.
            </p>
        </div>
    );
};
